/*
These functions make sure WordPress
and Foundation play nice together.
*/





jQuery(document).ready(function() {
	var $ = jQuery;
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	// jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
	// 	if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
	// 	  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
	// 	} else {
	// 	  jQuery(this).wrap("<div class='responsive-embed'/>");
	// 	}
	// });


  $('.detailsSelect').click(function(){
    var panelId = $(this).attr('data-panelid');
    
    $('.detailsSelect').removeClass('active');
    $('.content-drop').removeClass('active');
    
    $(this).addClass('active');
    $("#"+panelId).addClass('active');
    
  });

  $('.diagramSelect').click(function(){
    var diagramId = $(this).attr('data-diagramid');
    
    $('.diagramSelect').removeClass('active');
    $('.content-drop2').removeClass('active');
    
    $(this).addClass('active');
    $("#"+diagramId).addClass('active');
    
  });
  // $(".zoomClick").click(function() {
  //   $(".diagramPopup").fadeIn(500);
  // });
  // $(".diagramClose").click(function() {
  //   $(".diagramPopup").fadeOut(500);
  // });

  $('.zoomClick').click(function(){
    var el = $(this).attr('data-popupid');
    $(this).addClass('active');
    $('#'+el).addClass('active').fadeIn(200);   
 });
 
 $('.diagramClose').click(function(){
    $('.zoomClick').removeClass('active');
     $('.diagramPopup').fadeOut(300);
 });

  $(function () {
    var width = $("body").width();
    if (width > 680) {
    $(".homeContainerLink").hover(function () {
        $(this).find(".containerLink").slideToggle('slow');
    });
  }
});
$(function () {
  $(".dropdown-nav-menu-container-mobile").click(function () {
      $(this).find(".dropdown-menu-mobile").slideToggle('slow');
  });
});

    $('.hamburger-toggle').click(function(){
      $('.mobile-menu-drop').slideToggle(400);
      // $(this).siblings('.mobile-menu-drop').toggleClass('show-mobile-nav');
      $(this).children('.hamburgerMenu').toggleClass('menuIsOpened');
    });
  
    $(function(){
      var current = window.location.pathname;
      if(window.location.pathname === '/') {
        $('.box .home').addClass('active');
      }
      else if(window.location.pathname != '/') {
        $('.box .home').removeClass('active');
        $('.box a').each(function(){
          var $this = $(this);
          // if the current path is like this link, make it active
          if($this.attr('href').indexOf(current) !== -1){
              $this.addClass('active');
          }
      })
      }
  })

//accordian
$('#ServDtlIndustries_slider .slider-single').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '#ServDtlIndustries_slider .slider-nav',
  speed: 600,
  cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
});

$('#ServDtlIndustries_slider .slider-nav').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: '#ServDtlIndustries_slider .slider-single',
  dots: false,
  arrows: false,
  centerMode: true,
  speed: 400,
  focusOnSelect: true,
  centerPadding: '0px',
  loop: true,
  autoplay: false,
  infinite: false
});

    
}); 

